import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileManagementComponentService, FileWithId } from '../../../shared/services/file-management-component-service/file-management-component.service';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DropzoneComponent } from '../../../shared/components/dropzone/dropzone.component';

@Component({
  selector: 'sl-ui-kit-image-box',
  templateUrl: './image-box.component.html',
  styleUrls: ['./image-box.component.scss'],
  imports: [DropzoneComponent, TooltipModule],
  providers: [FileManagementComponentService]
})
export class ImageBoxComponent {
  @Output()
  imageUpdated = new EventEmitter<File>();
  private _imageModified = false;
  @Input()
  imageContainerStyle: string;
  @Input()
  accept = 'image/jpeg,image/jpg,image/png,image/gif';
  @Input()
  id: string;

  private _src: File | string = null;
  public get src(): File | string {
    return this._src;
  }
  @Input()
  public set src(value: File | string) {
    if (value != this._src) {
      this.loading = true;
    }
    this._src = value;
  }
  @Input()
  alt: string;
  @Input()
  editable = false;
  @Input()
  label: string;

  loading = false;
  setPristine() {
    this._imageModified = false;
  }
  constructor(private _fileManagementComponentService: FileManagementComponentService) {
    this._fileManagementComponentService.maxNumFiles = 1;
  }

  onFilesAdded(event) {
    if (event.rejectedFiles.length > 0) {
      return;
    }
    this._fileManagementComponentService.onFilesAdded(event);
    this._imageModified = true;
    this._reloadLogo(this._fileManagementComponentService.files[0]);
  }
  private _reloadLogo(fileWithId: FileWithId) {
    this._fileManagementComponentService.loadFileAsDataUrl(fileWithId.file, o => {
      this.src = o.filePreview;
      this.imageUpdated.emit(this.src as File);
    });
  }
  hasUnsavedChanges() {
    return this._imageModified;
  }
  public get files(): readonly File[] {
    return this._fileManagementComponentService.files.map(o => o.file);
  }
  getButtonRole() {
    if (!this.editable) {
      return 'image';
    }
    return 'button';
  }
  onImageLoad() {
    this.loading = false;
  }
}
